import axios from 'axios'

import config from './config.js'
import store from '../store'

const backendService = axios.create({
  baseURL: config.server.host + config.server.ns,
})

const getUserCreds = () => {
  return store.state.user
}


backendService.defaults.headers.post['Content-Type'] = 'application/json'

export const authenticate = async (credentials) => {
  return backendService.get('/autentikacio', {
    headers: {
      'Authorization': 'Basic ' + credentials
    }
  })
}

export const uploadContent = async (content, isTest=false) => {
  const endpoint = isTest ? '/rekordok/teszt' : '/rekordok'

  return backendService.post(endpoint, content, {
    headers: {
      'Authorization': 'Basic ' + getUserCreds()
    }
  })
}

export const uploadFormInputs = async (content, isTest=false) => {
  const endpoint = isTest ? '/rekord/teszt' : '/rekord'

  const requestBody = {
    rekord: {
      ...content
    }
  }

  return backendService.post(endpoint, requestBody, {
    headers: {
      'Authorization': 'Basic ' + getUserCreds()
    }
  })
}

export const getListValues = async (mapKey) => {
  return backendService.get(`/szotar/${mapKey}`, {
    headers: {
      'Authorization': 'Basic ' + getUserCreds()
    }
  })
}

export const statistics = async (bno, sex, county, ageGroup, startDate, endDate) => {
  let params = new URLSearchParams()
  startDate ? params.append('tol', startDate) : () => {}
  endDate ? params.append('ig', endDate) : () => {}
  sex ? params.append('nem', sex) : () => {}

  bno.length ? paramGen(params, 'bno', bno) : () => {}
  county.length ? paramGen(params, 'megye', county) : () => {}
  ageGroup.length ? paramGen(params, 'korcsoport', ageGroup) : () => {}
  
  return backendService.get('/statisztika', {
    params: params
  })
}

export const reports = async (credentials, taj, limit, startDate, endDate, id) => {
  let params = new URLSearchParams()
  startDate ? params.append('tol', startDate) : () => {}
  endDate ? params.append('ig', endDate) : () => {}
  taj ? params.append('taj', taj) : () => {}
  limit ? params.append('limit', limit) : () => {}
  id ? params.append('sorszam', id) : () => {}
  
  return backendService.get('/rekordok', {
    headers: {
      'Authorization': 'Basic ' + credentials
    },
    params: params
  })
}

export const headers = async (credentials, taj, limit, startDate, endDate, id) => {
  let params = new URLSearchParams()
  startDate ? params.append('tol', startDate) : () => {}
  endDate ? params.append('ig', endDate) : () => {}
  taj ? params.append('taj', taj) : () => {}
  limit ? params.append('limit', limit) : () => {}
  id ? params.append('sorszam', id) : () => {}

  return backendService.get('/fejlecek', {
    headers: {
      'Authorization': 'Basic ' + credentials
    },
    params: params
  })
}

export const changePassword = async (userName, oldPassword, newPassword) => {
  return backendService.post('/jelszovaltoztatas', {
    'felhasznalo_nev': userName,
    'regi_jelszo': oldPassword,
    'uj_jelszo': newPassword
  })
}

const paramGen = (par, name, prop) => {
  const array = prop.map(element => element.value).join(',')
  par.append(name, array)
}
  